import React, { PureComponent } from 'react';
import Button from './Button';

class ButtonDefault extends PureComponent {
    state = {};

    render() {
        let { classes = [], ...props } = this.props;
        return <Button {...props} classes={['fm-button__default', ...classes]} />;
    }
}

export default ButtonDefault;
